import { MESSAGE_TYPE_ID } from 'conversations-message-history/unpublished-messages/constants/messageTypes';
export const messageTypeKeyPath = [MESSAGE_TYPE_ID];